import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#193e2d',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#d89936',
    },
  },
  components: {
    // outlines on textfields when focused
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#193e2d',
          },
        },
      },
    },
    // labels
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#193e2d',
          },
        },
      },
    },
  },
});

export default theme;